export const formatReferenceNumber = (number: string) => {
  return number.match(/.{1,3}/g)?.join(" ");
};
